import Image from 'next/image'
import React, { useContext } from 'react'
import { Media } from './Media'
import { AdvertiserPrimaryButton } from './AdvertiserPrimaryButton'
import lokal_app_logo from '../../public/assets/lokal_app_logo.webp'
import { HamburgerAnimation } from '../components/HamburgerAnimation'
import { SecondaryButton } from '../components/SecondaryButton'
import classNames from 'classnames'
import Popover from 'antd/lib/popover'
import ImageWithBasePath from '../components/ImageWithBasePath'
import { HamburgerMenu } from '../components/HamburgerMenu'
import Constants from '../localization/en'
import { useRouterHook } from '../hooks/useRouterHook'
import { trackEvent } from '../analytics'
import { advertiserAnalyticOptions } from '../utils/functions'
import { useRouter } from 'next/router'
import { SharedContext } from '@/context/SharedContext'
import { AdvertiserContext } from '@/context/AdvertiserContext'

export const AdvertiserHeader = ({
  isHamburgerPresent = false,
  isPostAJobButtonPresent = false,
  isLogoClickable = false,
  imageClass = { height: '27px', width: '139.76px' },
  outerClass = 'h-[52px] px-[24px]',
  isProfileButtonPresent = false,
  postAJobButtonClass = 'w-[109px] h-[28px]',
  postAJobTextClass = '',
  isEnterprise = false,
  isDashboardButton = false
}) => {
  const { navigateToPagesInAdvertiser, replaceThePageInAdvertiser } = useRouterHook()

  const { loginDetails, utmParams, setMenuClicked, isMenuClicked } = useContext(SharedContext)

  const {
    isAdvertiserMenuClicked,
    setAdvertiserMenuClicked,
    setpostJobPresentStep,
    setPaymentSuccesss,
    isPaymentSuccess,
    setEditJobSubmissionId,
    setIsSuccess,
    setSubmittedJobId,
    setEditReportclicked,
    enterprisePlanOptions,
    setPayMentFailed,
    setFormData,
    setTempFormData,
    setSubmissionId,
    setReviewPageOpended,
    enterpriseLoginDetails,
    setEnterpriseLoginDetails,
    setAdvertiserBackModalOpen,
    advertiserBackModalClose
  } = useContext(AdvertiserContext)
  const isUserLogin = loginDetails?.isLogIn
  const router = useRouter()
  const isRecruiterCandidatePage = router?.asPath?.split('/').at(-1).includes('candidate-listing')

  return (
    <div
      className={classNames(
        'sticky top-0 z-[100] flex  items-center justify-between   bg-[white]    shadow-advertiserHeader sm:h-[82px] sm:px-[40px] md:justify-between',
        outerClass
      )}
    >
      <div
        className={classNames(` relative cursor-pointer  sm:h-[30.91px]   sm:w-[160px]`)}
        style={{ height: imageClass.height, width: imageClass.width }}
        onClick={() => {
          isLogoClickable &&
            navigateToPagesInAdvertiser({ pathName: 'advertiserHomePage', as: '', isHome: true })
        }}
      >
        <Image src={lokal_app_logo} fill alt="getlokalapp logo" priority={true} />
      </div>

      <div className="flex flex-1 justify-end">
        {isDashboardButton && (
          <div className="h-[40px] w-[164px] cursor-pointer ">
            <AdvertiserPrimaryButton
              title={'Go to dashboard'}
              isCPMFlow={true}
              isCsat={true}
              isb2b={true}
              isArrowPresent={false}
              extraClassName="bg-white border-[1px] border-solid border-[#4B4B4B] hover:border-[1px]"
              onClick={() => {
                replaceThePageInAdvertiser({
                  pathName: 'advertiserDashboardPage',
                  as: 'dashboard'
                })
              }}
            />
          </div>
        )}
      </div>
      {(isHamburgerPresent || isPostAJobButtonPresent) && (
        <>
          <div className={classNames(`flex items-center  space-x-[12px] sm:space-x-[24px]`)}>
            <>
              {isPostAJobButtonPresent && (
                <SecondaryButton
                  icon="rightArrowBlack3"
                  title="Post a job"
                  className={classNames(
                    ' flex  cursor-pointer border-[4px] border-[#FFBB00] bg-secondary  ',
                    postAJobButtonClass
                  )}
                  imageClass="mr-[0px] ml-[4px] "
                  imageDetails={{ width: 20, height: 20 }}
                  onClick={() => {
                    setEditJobSubmissionId()
                    setIsSuccess('default')
                    setSubmissionId(null)
                    setSubmittedJobId(null)
                    setPayMentFailed({
                      isFailed: false,
                      selectedPlan: null,
                      selectedPack: null
                    })
                    setIsSuccess('default')
                    trackEvent({
                      name: 'tap_post_job_CTA',
                      searchParams: { ...utmParams },
                      options: advertiserAnalyticOptions({
                        source: isRecruiterCandidatePage ? 'candidate_portal' : 'dashboard',
                        enterprise: isEnterprise
                      }),
                      isFbPixelThere: false
                    })
                    if (isPaymentSuccess) {
                      setPaymentSuccesss(false)
                    }

                    setpostJobPresentStep(1)
                    setFormData({})
                    setTempFormData({})

                    setReviewPageOpended(false)
                    navigateToPagesInAdvertiser({
                      pathName: 'advertiserPostJob',
                      as: 'post-job'
                    })
                  }}
                  imageAfterTitle={true}
                  titleClass={classNames('whitespace-nowrap', postAJobTextClass)}
                />
              )}

              {isHamburgerPresent && (
                <Media at="sm">
                  <div
                    id="header_burger_menu_1"
                    className="flex h-fit w-fit  items-center"
                    onClick={() => {
                      setMenuClicked((prv) => !prv)
                    }}
                  >
                    <HamburgerAnimation {...{ isClicked: isMenuClicked }} />
                  </div>
                </Media>
              )}
              {isProfileButtonPresent && (
                <Media greaterThanOrEqual="sm" className="cursor-pointer">
                  <Popover
                    trigger="click"
                    placement="bottomLeft"
                    showArrow={false}
                    overlayClassName="p-[0px] pt-[10px] m-[0px]"
                    open={isAdvertiserMenuClicked}
                    content={() => (
                      <HamburgerMenu
                        {...{
                          setMenuClicked: setAdvertiserMenuClicked,
                          isMenuClicked: isAdvertiserMenuClicked,
                          enterpriseLoginDetails,
                          setEnterpriseLoginDetails,
                          setAdvertiserBackModalOpen,
                          setAdvertiserMenuClicked,
                          advertiserBackModalClose
                        }}
                      />
                    )}
                  >
                    <div
                      className={classNames(
                        'flex h-[38px] items-center space-x-[8px] rounded-[4px] border-solid py-[8px]  px-[12px] ',
                        isEnterprise ? 'border-xs border-[#191919]' : 'border-sm border-[black]'
                      )}
                      onClick={() => {
                        setAdvertiserMenuClicked((prv) => !prv)
                        trackEvent({
                          name: 'tap_my_profile',
                          searchParams: { ...utmParams },
                          options: advertiserAnalyticOptions({ enterprise: isEnterprise }),
                          isFbPixelThere: false
                        })
                      }}
                    >
                      <div className="relative h-[24px] w-[24px]">
                        <ImageWithBasePath src="person_in_circle2" fill alt={'profile photo'} />
                      </div>
                      {isUserLogin ? (
                        <div className="relative h-[24px] w-[24px]">
                          <ImageWithBasePath src="downArrowIconBlack" fill alt="menu icon" />
                        </div>
                      ) : (
                        <div className="font-noto-sans text-[16px] font-bold leading-[21.79px] text-[#323232] ">
                          {Constants.login}
                        </div>
                      )}
                    </div>
                    <style jsx global>{`
                      .ant-popover .ant-popover-inner {
                        background: #ffffff;
                        border: 1px solid rgba(64, 64, 64, 0.1);
                        /* Shadow-Card */

                        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08),
                          0px 4px 8px rgba(14, 31, 53, 0.05);
                        border-radius: 10px;
                        padding: 0px;
                      }
                    `}</style>
                  </Popover>
                </Media>
              )}
            </>
          </div>
        </>
      )}
    </div>
  )
}
